import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Line } from './Line';
import { Step } from './Step';
import styles from './StepBar.module.scss';
export const StepBar = ({ activeIndex = 0, ariaLabel, steps, testId, }) => {
    return (_jsx("ul", { className: `d-flex mx-auto py-2x ${styles.stepBar}`, "data-testid": testId ?? 'step-bar', "aria-label": ariaLabel, children: steps.map((step, stepIndex) => (_jsxs("li", { "aria-current": activeIndex === stepIndex, className: "d-flex", children: [stepIndex > 0 && _jsx(Line, { position: stepIndex - 1, activeIndex: activeIndex }), _jsx(Step, { activeIndex: activeIndex, position: stepIndex, step: step }, step.title)] }, step.title))) }));
};
